import { render, staticRenderFns } from "./HistoryFilterDefaultLayout.vue?vue&type=template&id=2cdac3c2&scoped=true&"
import script from "./HistoryFilterDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./HistoryFilterDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdac3c2",
  null
  
)

export default component.exports